export default {"src":"/_next/static/media/pair-1.424b2972.svg","height":337,"width":443,"blurWidth":0,"blurHeight":0};